import { call, put, takeLatest } from 'redux-saga/effects';
import apiCall from '../helpers/ApiCall';
import apiRoot from '../consts/apiRoot';
import { FETCH_CHANNELS, FETCH_CHANNELS_SUCCESS, FETCH_CHANNELS_FAIL } from '../redux/Channels';
import { GET } from '../consts/Methods';

function* fetchChannelsFlow() {
  try {
    const endpoint = `${apiRoot}/channels`;
    const response = yield call(apiCall, { method: GET, endpoint, });
    yield put(FETCH_CHANNELS_SUCCESS(response));
  } catch (error) {
    yield put(FETCH_CHANNELS_FAIL(error));
  }
}

export default function* FetchChannels() {
  yield takeLatest(FETCH_CHANNELS, fetchChannelsFlow);
}
